export default function Newsletter() {
  const handleSubmit = (e) => {
    e.preventDefault();
    // TODO: Implement newsletter signup
    alert('Newsletter signup coming soon!');
  };

  return (
    <section className="newsletter">
      <div className="container">
        <div className="content">
          <p style={{ marginBottom: '-0.7em' }}><strong>Subscribe to get new posts by email.</strong></p>
          
          <form className="newsletter-form" onSubmit={handleSubmit}>
            <div className="newsletter-input">
              <input 
                type="email" 
                placeholder="your@email.com" 
                required 
                aria-label="Email address"
              />
              <button type="submit">Subscribe</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}

